export const get = (path, obj = {}, separator = ".") => {
    const properties = Array.isArray(path) ? path : path.split(separator);
    return properties.reduce((prev, curr) => prev === null || prev === void 0 ? void 0 : prev[curr], obj);
};
